import { useEffect, useRef } from 'react';

import { isSameLanguage } from 'src/data/generation';
import { useProjectActions } from 'src/store';

export const useMaintainCorrectTovLanguage = ({
  customModels,
  toneOfVoices,
  selectedTov,
  selectedCustomModelId,
  language,
}) => {
  const projectActions = useProjectActions();

  // Make sure that currently selected TOV is in the correct language. If not, clear the selection.
  useEffect(() => {
    const customModel = customModels.find((cm) => cm.id === selectedCustomModelId);
    const toneOfVoice = toneOfVoices.find((tov) => tov.id === selectedTov);
    const tovLanguage = selectedCustomModelId
      ? customModel?.brandVoiceLanguage
      : toneOfVoice?.brandVoiceLanguage;

    if (tovLanguage && !isSameLanguage(tovLanguage, language)) {
      projectActions.clearTovInputs();
    }
  }, [language, selectedTov, selectedCustomModelId, projectActions, toneOfVoices, customModels]);

  // Clear selected TOV when language changes
  const initialLanguage = useRef(language);
  useEffect(() => {
    if (initialLanguage.current !== language) {
      projectActions.clearDraftToneOfVoice();
      projectActions.clearSelectedCustomModelId();
      initialLanguage.current = language;
    }
  }, [language, projectActions]);
};
